import MicroModal from 'micromodal';
import { defaultSettings } from './settings';
import { openNextModal, closeModal } from './utils';

MicroModal.modalSettings = defaultSettings;

const fModalPosition = () => {
    const modal = document.querySelector('.modal.is-open .modal__container');
    const modalParent = document.querySelector(
        '.modal.is-open .modal__overlay'
    );
    if (
        typeof modal !== 'undefined' &&
        modal != null &&
        typeof modalParent !== 'undefined' &&
        modalParent != null
    ) {
        if (modal.clientHeight > modalParent.clientHeight) {
            modalParent.classList.add('modal__overlay--block');
        } else {
            modalParent.classList.remove('modal__overlay--block');
        }
    }
};

const fModalInit = (modal: any) => {
    // Close modal on drag
    const modalClose = modal.querySelectorAll(
        '.modal__close:not([data-init="true"])'
    );
    modalClose.forEach((item: any) => {
        item.setAttribute('data-init', 'true');

        let start: number;

        const parent = item.parentNode;

        item.addEventListener('touchstart', (e: any) => {
            if (window.matchMedia('(max-width: 767px)')) {
                e.stopPropagation();
                const touch = e.touches[0] || e.changedTouches[0];
                start = touch.pageY;
            }
        });
        item.addEventListener('touchmove', (e: any) => {
            if (window.matchMedia('(max-width: 767px)')) {
                e.stopPropagation();
                const touch = e.touches[0] || e.changedTouches[0];
                const y = touch.pageY;
                const diff = y - start;
                if (diff > 0) {
                    parent.style.setProperty('--modal-top', `${diff}px`);
                }
            }
        });
        item.addEventListener('touchend', (e: any) => {
            if (window.matchMedia('(max-width: 767px)')) {
                closeModal();
                setTimeout(() => {
                    parent.style.removeProperty('--modal-top');
                }, 300);
            }
        });

        item.addEventListener('click', () => {
            closeModal();
        });
    });

    const modalContainer = modal.querySelectorAll(
        '.modal__container:not([data-init="true"])'
    );
    modalContainer.forEach((item: any) => {
        item.setAttribute('data-init', 'true');
        item.addEventListener('scroll', () => {
            item?.style.setProperty(
                '--modal-scroll-top',
                `${item.scrollTop}px`
            );
        });
    });
};

export const modalOpen = (modalID: string) => {
    const modal = document.getElementById(modalID);
    if (modal !== null && modal !== undefined) {
        fModalInit(modal);
        openNextModal(modalID);
        setTimeout(() => {
            fModalPosition();
        }, 100);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const scrollWidth =
        window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scroll-width', `${scrollWidth}px`);

    MicroModal.init(defaultSettings);

    document.body.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (
            target.matches('[data-micromodal]') ||
            target.closest('[data-micromodal]')
        ) {
            e.preventDefault();
            const modalID =
                target.getAttribute('data-micromodal') ||
                target
                    .closest('[data-micromodal]')
                    ?.getAttribute('data-micromodal') ||
                '';
            if (modalID) {
                modalOpen(modalID);
            }
        }
    });

    window.addEventListener('resize', () => {
        setTimeout(() => {
            fModalPosition();
        }, 100);
    });
});
